export const GET_FALLBACK_LAYOUT = 'GET_FALLBACK_LAYOUT';

/**
 * Action to get fallback layout data (navtree, metanav, etc.) for error pages.
 * @param url The base URL to fetch data from (e.g., the language root).
 */
export function getFallbackLayout(url: string) {
  return {
    type: GET_FALLBACK_LAYOUT,
    request: {
      op: 'get',
      path: `${url}?expand=navroot,navtree,metanav,breadcrumbs,searchnav&expand.navtree.depth=3`,
    },
  };
}
